export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_CURRENCY_FORMAT = '1.2-2';

export const CURRENCY = {
  USD: {
    code: 'USD',
    symbol: DEFAULT_CURRENCY_FORMAT,
    name: 'US Dollar',
  },
  EUR: {
    code: 'EUR',
    symbol: DEFAULT_CURRENCY_FORMAT,
    name: 'Euro',
  },
  GBP: {
    code: 'GBP',
    symbol: DEFAULT_CURRENCY_FORMAT,
    name: 'British Pound',
  },
};
